module.exports = __webpack_public_path__ + "static/img/liandong2.9810074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/liandong2.png
// module id = hGq/
// module chunks = 24